import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC } from 'react'

import { BlogPreview } from '@/components/blogSlices/BlogPreview'
import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const ScopeThree: FC = () => {
    return (
        <Box>
            <TwoColumnLayout
                leftCol={6}
                rightCol={5}
                columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}
            >
                <TitleAndParagraph
                    sx={{ maxWidth: '588px' }}
                    title={`Help your customers get regulation-ready`}
                    paragraph={
                        'In 2024, over 50,000 companies will need to report on their scope 3 to comply with regulations. Cultivate customer loyalty by equipping them with the industry-leading emission calculations they need to get regulation-ready.'
                    }
                    snippet={
                        <BlogPreview
                            title={
                                'CSRD: What are scope 3 emissions, and why are they a nightmare?'
                            }
                            url={'/blog/csrd-what-are-scope-3-emissions'}
                        />
                    }
                />
                <Box sx={{ display: 'flex' }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '0',
                            paddingBottom: '74.15%',
                            position: 'relative',
                            img: {
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0,
                                width: '100%',
                                height: '100%',
                            },
                        }}
                    >
                        <Image
                            width={975}
                            height={723}
                            src={'/images/scope-3-report.png'}
                            alt={'scope three'}
                        />
                    </Box>
                </Box>
            </TwoColumnLayout>
        </Box>
    )
}

export default ScopeThree
